import SocialBar from "../components/SocialBar/SocialBar";

export default function PoliticasDeCompra() {
  return (
    <section
      className="bg-dark-gray relative text-white px-6 md:px-12 lg:px-20 py-12 md:py-20 bg-cover bg-center"
      style={{ backgroundImage: "url('/images/fondoBlanco.webp')" }}
    >
      {/* dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      <div className="relative mx-auto text-center max-w-7xl">
        {/* --- Header --- */}
        <h2 className="text-white text-4xl md:text-6xl font-extrabold mb-6 md:mb-10">
          POLÍTICAS DE COMPRA
        </h2>

        <p className="text-gray-300 text-lg md:text-2xl mb-16 max-w-4xl mx-auto px-4">
          Conoce las políticas que rigen las compras dentro de nuestra plataforma.
        </p>

        {/* --- Content --- */}
        <div className="text-left mx-auto max-w-5xl space-y-10 text-gray-200 text-lg md:text-xl leading-relaxed px-4">
          <p>
            En <strong>Omova Carbon Fiber</strong>, nuestras políticas de compra están
            diseñadas para asegurar una experiencia transparente y satisfactoria para todos
            nuestros clientes. A continuación, te proporcionamos un resumen general de las
            políticas que aplican cuando realizas compras a través de nuestra plataforma.
          </p>

          {/* 1. Acceso a la Plataforma de Compra */}
          <section>
            <h3 className="text-2xl font-bold mb-4">
              1. Acceso a la Plataforma de Compra
            </h3>
            <p>
              Para acceder a nuestros precios y realizar compras, es necesario registrarse
              previamente en nuestra plataforma. El registro se realiza a través del formulario
              disponible en esta landing page. Una vez registrado y aprobado, recibirás un acceso
              único que te permitirá explorar nuestro catálogo y realizar tus pedidos.
            </p>
          </section>

          {/* 2. Realización de Pedidos */}
          <section>
            <h3 className="text-2xl font-bold mb-4">2. Realización de Pedidos</h3>
            <p>
              Los pedidos deben realizarse directamente a través de nuestra plataforma de compra,
              donde podrás seleccionar los productos deseados, agregar tus datos de envío y elegir
              el método de pago. Una vez que hayas completado el pedido, deberás enviar el
              comprobante de pago para su validación.
            </p>
          </section>

          {/* 3. Precios y Descuentos */}
          <section>
            <h3 className="text-2xl font-bold mb-4">3. Precios y Descuentos</h3>
            <p>
              Los precios mostrados en nuestra plataforma son personalizados según el volumen y la
              frecuencia de tus compras. Ofrecemos descuentos para compras al por mayor, los cuales
              se reflejarán automáticamente en tu perfil de cliente registrado.
            </p>
          </section>

          {/* 4. Modificaciones y Cancelaciones */}
          <section>
            <h3 className="text-2xl font-bold mb-4">4. Modificaciones y Cancelaciones</h3>
            <p>
              Si necesitas modificar o cancelar un pedido, deberás comunicarte con nuestro equipo de
              atención al cliente lo antes posible, a través de{" "}
              <a
                href="mailto:contacto@omova.com.mx"
                className="text-primary-green underline hover:text-green-400 transition-colors"
              >
                contacto@omova.com.mx
              </a>{" "}
              o por WhatsApp. Haremos todo lo posible por atender tu solicitud antes de que el
              pedido sea procesado y enviado.
            </p>
          </section>

          {/* 5. Facturación */}
          <section>
            <h3 className="text-2xl font-bold mb-4">5. Facturación</h3>
            <p>
              Puedes solicitar una factura al momento de realizar tu pedido. La factura será
              generada y estará disponible en tu cuenta dentro de la plataforma una vez que el pago
              sea confirmado.
            </p>
          </section>

          {/* 6. Envíos */}
          <section>
            <h3 className="text-2xl font-bold mb-4">6. Envíos</h3>
            <p>
              Realizamos envíos a todo México. Los detalles sobre costos y tiempos de envío estarán
              disponibles en la plataforma una vez que completes tu compra. Los costos de envío
              varían según la ubicación y el peso del pedido. Recibirás un número de rastreo por
              WhatsApp para que puedas seguir tu pedido una vez que haya sido enviado.
            </p>
          </section>

          {/* 7. Garantías y Devoluciones */}
          <section>
            <h3 className="text-2xl font-bold mb-4">7. Garantías y Devoluciones</h3>
            <p>
              Todos nuestros productos cuentan con una garantía de 30 días a partir de la recepción.
              Si necesitas hacer una devolución, es necesario que te pongas en contacto con nosotros
              dentro de este periodo. Ten en cuenta que no aceptamos devoluciones de ciertos
              productos específicos, como la fibra de carbono tejida, siguiendo nuestras políticas
              de devolución detalladas en la plataforma.
            </p>
          </section>

          {/* 8. Soporte al Cliente */}
          <section>
            <h3 className="text-2xl font-bold mb-4">8. Soporte al Cliente</h3>
            <p>
              Si tienes alguna pregunta o necesitas asistencia durante el proceso de compra, nuestro
              equipo de atención al cliente está disponible para ayudarte a través de los canales de
              contacto proporcionados en la plataforma, como WhatsApp o correo electrónico.
            </p>
          </section>

          <section>
            <p>
              Para cualquier duda adicional sobre nuestras políticas de compra, no dudes en
              contactarnos a través de{" "}
              <a
                href="mailto:contacto@omova.com.mx"
                className="text-primary-green underline hover:text-green-400 transition-colors"
              >
                contacto@omova.com.mx
              </a>.
            </p>
          </section>
          <SocialBar />
        </div>
      </div>
    </section>
  );
}
